import { registerPlugin } from '@capacitor/core';
import type { ProcessLifecyclePlugin } from './definitions';

const ProcessLifecycle = registerPlugin<ProcessLifecyclePlugin>('ProcessLifecycle');

export * from './definitions';
export { ProcessLifecycle };
